module.exports = __webpack_public_path__ + "img/SWIFT-2021.fd57f43d.png";